import React from 'react'

import { Button, ButtonProps } from '@octane/spark'

const FormSaveButton = ({ children, ...props }: ButtonProps) => (
    <Button {...props}>{children ?? 'Save Application'}</Button>
)

export default FormSaveButton
